module.exports = __webpack_public_path__ + "img/prt0081bqz.prt.3e49d788.jpg";